import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Course } from 'src/app/models/course.model';

@Component({
  selector: 'app-courses-list',
  templateUrl: './courses-list.component.html',
  styleUrls: ['./courses-list.component.scss'],
  standalone: false
})
export class CoursesListComponent {

  @Input() courses!: Course[];
  @Output() courseClicked: EventEmitter<Course> = new EventEmitter<Course>();
  
  editCourseVisible: boolean = false;
  courseToEdit?: Course;

  constructor() {}

  ngOnInit() {
  }

  handleCourseClick(course: Course) {
    this.courseClicked.emit(course);
  }

  editCourse(event: Event, course: Course) {
    event.stopPropagation();
    this.courseToEdit = course;
    this.editCourseVisible = true;
  }
}
